/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Dispatch, SetStateAction, useEffect } from "react";
import { Tabs, TabsProps } from "antd";
import { useReactiveVar } from "@apollo/client";
import { ServiceTypes } from "../../../types/types";
import { Colors } from "../../../constants/Colors";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { __currentUser__ } from "../../../graphql/policies";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import NoPermission from "../../../components/others/NoPermission";
import Spinner from "../../../components/layout/spinner/Spinner";
import ServiceBannerTabContent from "./components/ServiceBannerTabContent";
import TemplatesTabContent from "./components/TemplateTabContent";

interface ServiceBannerAndIconProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "Service Icon",
    children: <ServiceBannerTabContent />,
  },
  {
    key: "2",
    label: "Default",
    children: <TemplatesTabContent />,
  },
];

const ServiceBannerAndIcon = ({
  setSelectedService,
  setSelectSubItem,
}: ServiceBannerAndIconProps) => {
  const currentUser = useReactiveVar(__currentUser__);
  const {
    data: userPrograms,
    loading: userProgramsLoading,
    error: userProgramsError,
  } = useGetUserProgramsByServiceQuery({
    variables: {
      userId: parseInt(renderDecodedId(currentUser?.id)),
      serviceId: 2,
    },
  });

  const onChange = (key: string) => {
    console.log(key);
  };

  useEffect(() => {
    setSelectedService(ServiceTypes.CLUB_APP);
    setSelectSubItem("Service Icon");
  }, []);

  if (userProgramsError) {
    message.error(
      renderAntDMessageConfig(
        "Something went wrong. Please contact your system administrator."
      )
    );
  }

  if (userProgramsLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Service Banner"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <div>
      <div className="header" style={{ backgroundColor: Colors.white }}>
        <p className="header-title" style={{ color: Colors.darkGrey }}>
          Service Icon
        </p>
      </div>
      <Tabs
        defaultActiveKey="1"
        items={items}
        onChange={onChange}
        size="small"
        tabBarStyle={{
          paddingLeft: 24,
          backgroundColor: Colors.white,
          height: 50,
        }}
      />
    </div>
  );
};

export default ServiceBannerAndIcon;
